import * as React from 'react';

import { track } from '@klokhuis/core/Analytics/libs/analytics-lib';
import { AnalyticsEvent } from '@klokhuis/core/Analytics/types';
import { getSearchFilterAppliedEventPayload } from '@klokhuis/core/Analytics/utilities/getSearchFilterAppliedEventPayload';
import { ListingRequest } from '@klokhuis/core/ApiClient/Klokhuis';
import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';
import { FilterActionTypes } from '@klokhuis/modules/Properties/context/types';

import { getFilterCount } from '../pages/Listings/components/FilterUtils';

import { useListingStateDispatcher } from './useListingStateDispatcher';
import { useUpdateQueryParams } from './useUpdateQueryParam';

export const useFilterStateDispatcher = () => {
  const { dispatch } = ListingsContext.useContext();
  const { listingStateDispatcher } = useListingStateDispatcher();
  const { updateQueryParams } = useUpdateQueryParams();
  const filterStateDispatcher = React.useCallback(
    async (formState: ListingRequest | Partial<ListingRequest>) => {
      dispatch({
        type: FilterActionTypes.UPDATE_FILTER,
        payload: formState,
      });

      dispatch({
        type: FilterActionTypes.UPDATE_FILTER_COUNT,
        payload: getFilterCount(formState),
      });

      updateQueryParams({
        pageNo: formState.pageNo ? formState.pageNo?.toString() : '1',
        searchview: formState.searchview?.toString() || '1',
      });

      track(AnalyticsEvent.SearchFilterApplied, {
        filtertype: getSearchFilterAppliedEventPayload(formState),
      });
      await listingStateDispatcher(formState);
    },
    [dispatch, listingStateDispatcher, updateQueryParams],
  );

  return { filterStateDispatcher };
};
